module.exports = require('../../full/array/from');
